/**
 * IWW GTM Universal Tracker
 *
 * Dieses Script wird als IIFE innerhalb der 'bundle.js' im <head> geladen.
 * Da die 'bundle.js' mit dem 'defer'-Attribut eingebunden ist, erfolgt die Ausführung erst nach dem vollständigen Parsen des HTML (DOM ist bereit).
 * Ein zusätzlicher 'DOMContentLoaded'-Listener ist daher nicht nötig.
 */
(function() {
    'use strict';

    // Sicherstellen, dass dataLayer existiert (Robuster Check)
    const getDataLayer = () => window.dataLayer = window.dataLayer || [];

    // Wandelt 'gtmElementId' oder 'myAttribute' in 'element_id' bzw. 'my_attribute' um
    const formatKey = (key) => key
        .replace(/^gtm/, '') // Entfernt 'gtm' am Anfang (case-sensitive)
        .replace(/([A-Z])/g, '_$1') // Fügt Underscore vor Großbuchstaben ein
        .toLowerCase()
        .replace(/^_/, ''); // Entfernt führenden Underscore

    // Zentrale Logik für Payload-Erstellung
    const pushGtmEvent = (eventName, dataset = {}) => {
        if (!eventName) return;

        // Transformiert das komplette Dataset in einem Rutsch
        const customProps = Object.entries(dataset).reduce((acc, [key, value]) => {
            if (key !== 'gtmEvent') {
                acc[formatKey(key)] = value;
            }
            return acc;
        }, {});

        const baseState = getDataLayer().find(item => item.shortcut !== undefined) || {};

        const payload = {
            event: eventName,
            ...baseState,
            ...customProps,
            timestamp: new Date().toISOString()
        };

        getDataLayer().push(payload);
        console.log(`%c[GTM Debug] Event → ${eventName}`, 'color: #00ff00; font-weight: bold;', payload);
    };

    // Prüft auf den kurzlebigen Login-Cookie aus der Middleware
    const checkLoginCookie = () => {
        const cookieName = 'gtm_login_pending=';
        if (document.cookie.split(';').some((item) => item.trim().startsWith(cookieName))) {

            // Event feuern über die zentrale Logik
            pushGtmEvent('login');

            // Cookie sofort löschen
            document.cookie = 'gtm_login_pending=; Max-Age=-99999999; Path=/;';
        }
    };

    // Observer & Event Listener (Logik bleibt sauber getrennt)
    const initPaywallObserver = () => {
        const elements = document.querySelectorAll('[id^="paywall"]');

        // Falls Elemente zum Startzeitpunkt noch nicht da sind (dynamisches Nachladen)
        if (!elements.length) return false;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // das Element ist zu mindestens 10% sichtbar
                if (entry.isIntersecting) {
                    pushGtmEvent('paywall', {
                        ...entry.target.dataset,
                        elementId: entry.target.id
                    });

                    // Beobachtung für dieses spezifische Element stoppen
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });

        elements.forEach(el => observer.observe(el));
        return true;
    };

    // Start-Logik mit Fallback für verzögert gesetzte Flags oder dynamische Inhalte
    const startTracking = () => {
        // den Login-Cookie prüfen (höchste Priorität nach Redirect)
        checkLoginCookie();

        // Direkte Prüfung auf Elemente ODER auf das globale Flag
        const paywallInitialized = initPaywallObserver();

        // Falls Flag gesetzt, aber Elemente noch nicht im DOM (Timing-Sicherheit)
        if (!paywallInitialized && window.hasPaywall) {
            const retryInterval = setInterval(() => {
                if (initPaywallObserver()) clearInterval(retryInterval);
            }, 200);
            // Nach 3 Sekunden aufgeben, um Ressourcen zu schonen
            setTimeout(() => clearInterval(retryInterval), 3000);
        }
    };

    // Da 'defer' Scripte nach dem HTML-Parsing laufen, starten wir direkt.
    // Wir prüfen zur Sicherheit trotzdem den readyState.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startTracking);
    } else {
        startTracking();
    }

    // Globaler Klick-Delegator
    document.addEventListener('click', (e) => {
        const el = e.target.closest('[data-gtm-event]');
        if (!el || el.type === 'submit' || (el.tagName === 'BUTTON' && el.form)) return;
        pushGtmEvent(el.dataset.gtmEvent, el.dataset);
    });

    // Form-Submit-Handler
    document.addEventListener('submit', (e) => {
        // Sucht das Element mit dem Event-Dataset innerhalb des absendenden Formulars
        const btn = e.target.querySelector('[data-gtm-event]');
        if (btn) pushGtmEvent(btn.dataset.gtmEvent, btn.dataset);
    });

})();
